(function () {
    'use strict';

    let module = angular.module("imApp");

    module.factory("findCustomersService", ['$ihttp', function ($ihttp) {
        let service = {
            getFindCustomers: function (parms) {
                return $ihttp.post({
                    method: 1306,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
